// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"5727c6bb","374":"3bb7a755","388":"f104d97e","637":"3181a730","666":"52f10f43","762":"49e4bc27"}[chunkId] + ".chunk.js";
};